import { Repository } from '@sensenet/client-core';
import { createContext } from 'react';
/**
 * Context that stores the current Repository instance
 */

export const RepositoryContext = /*#__PURE__*/createContext(new Repository());
RepositoryContext.displayName = 'RepositoryContext';
//# sourceMappingURL=repository.js.map